import { combineReducers } from "redux";

import getTabsContent from "./getTabsContent";
import filterListResearchReport from "./filterListResearchReport";
import getListResearchReport from './getListResearchReport'
import getResearchReportDetail from './getResearchReportDetail'


const researchReportReducer = combineReducers({
    getTabsContent,
    filterListResearchReport,
    getListResearchReport,
    getResearchReportDetail
});

export default researchReportReducer;
